(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charms-quiz-one"] && !Shopify.designMode) return;
  try {
    
  /* Port of the prelander script, scoped to the element.

     THIS FILE CONTAINS NO USER-FACING TEXT. Every string is rendered into the
     markup by Liquid from section settings. The script only reads slugs off
     data- attributes and toggles which elements are visible, so translating the
     quiz never requires touching it. */
  class CharmsQuizOne extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.total = parseInt(this.dataset.total, 10) || 6;
      this.loadingMs = parseInt(this.dataset.loadingMs, 10) || 3600;
      this.storeKey = this.dataset.storeKey || 'charms-quiz-one';

      this.screens = this.all('[data-cq1-screen]');
      if (!this.screens.length) return;

      this.progress = this.one('[data-cq1-progress]');
      this.progressFill = this.one('[data-cq1-progress-fill]');
      this.backBtn = this.one('[data-cq1-back]');

      this.answers = {};
      this.current = 0;

      this.bindClicks();
      this.bindBack();
      this.bindSlider();

      this.paintCounters();
      this.paintMultiCounter(0);
      this.boot();
    }

    one(sel) { return this.querySelector(sel); }
    all(sel) { return Array.prototype.slice.call(this.querySelectorAll(sel)); }

    screenAt(index) {
      for (var i = 0; i < this.screens.length; i++) {
        if (parseInt(this.screens[i].dataset.cq1Screen, 10) === index) return this.screens[i];
      }
      return null;
    }

    track(name, params) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    }

    /* History is unavailable in some embedded contexts, sandboxed iframes and
       certain in-app browsers. The quiz must keep working without it, so every
       call is guarded and failure is silent. */
    setHash(index) {
      var target = '#step' + index;
      if (window.location.hash === target) return;
      try {
        window.history.replaceState(null, '', target);
      } catch (e) {
        try { window.location.hash = target; } catch (e2) { /* no history at all */ }
      }
    }

    save() {
      try {
        window.sessionStorage.setItem(this.storeKey, JSON.stringify({ a: this.answers, s: this.current }));
      } catch (e) { /* private mode */ }
    }

    restore() {
      try {
        var raw = window.sessionStorage.getItem(this.storeKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }

    /* Numerals go through Intl so locales that expect their own digits get them. */
    paintCounters() {
      var fmt = new Intl.NumberFormat(document.documentElement.lang || undefined);
      var tpl = this.dataset.countTpl || '';
      var total = this.total;
      this.all('[data-cq1-count]').forEach(function (el) {
        var n = parseInt(el.dataset.cq1Count, 10);
        el.textContent = tpl.replace('{n}', fmt.format(n)).replace('{total}', fmt.format(total));
      });
    }

    /* ---------- navigation ---------- */
    show(index) {
      this.screens.forEach(function (s) {
        var isTarget = parseInt(s.dataset.cq1Screen, 10) === index;
        s.classList.toggle('cq1-is-active', isTarget);
        if (isTarget) s.removeAttribute('hidden');
        else s.setAttribute('hidden', '');
      });

      this.current = index;
      var isQuestion = index >= 1 && index <= this.total;

      if (this.progress) {
        if (isQuestion) {
          this.progress.removeAttribute('hidden');
          if (this.progressFill) this.progressFill.style.inlineSize = (index / this.total * 100) + '%';
        } else {
          this.progress.setAttribute('hidden', '');
        }
      }

      if (this.backBtn) {
        if (isQuestion && index > 1) this.backBtn.removeAttribute('hidden');
        else this.backBtn.setAttribute('hidden', '');
      }

      this.setHash(index);

      var screen = this.screenAt(index);
      var heading = screen && screen.querySelector('h1, h2');
      if (heading && index > 0) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
      window.scrollTo(0, 0);
      this.save();
    }

    next() {
      if (this.current === this.total) { this.runResult(); return; }
      this.show(this.current + 1);
    }

    /* ---------- answering ---------- */
    bindClicks() {
      var self = this;
      this.addEventListener('click', function (e) {
        var chip = e.target.closest('.cq1-chip');
        if (chip) { self.pickMulti(chip); return; }

        var opt = e.target.closest('.cq1-opt, .cq1-card');
        if (opt) { self.pickSingle(opt); return; }

        var goto = e.target.closest('[data-cq1-goto]');
        if (goto) {
          if (self.current === 0) self.track('quiz_start');
          self.show(parseInt(goto.dataset.cq1Goto, 10));
          return;
        }

        var manual = e.target.closest('[data-cq1-advance-manual]');
        if (manual && manual.getAttribute('aria-disabled') !== 'true') { self.recordAndAdvance(manual); return; }

        var evt = e.target.closest('[data-cq1-event]');
        if (evt) self.track(evt.dataset.cq1Event, { result: self.currentResultId() });
      });
    }

    pickSingle(el) {
      var screen = el.closest('[data-cq1-screen]');
      if (!screen) return;
      screen.querySelectorAll('[role="radio"]').forEach(function (n) { n.setAttribute('aria-checked', 'false'); });
      el.setAttribute('aria-checked', 'true');

      var q = screen.dataset.cq1Question;
      this.answers[q] = {
        answer: el.dataset.cq1Answer,
        collection: el.dataset.cq1Collection || null
      };
      this.track('quiz_question_answered', { question: q, answer: this.answers[q].answer });
      this.save();

      if (el.hasAttribute('data-cq1-advance')) {
        var self = this;
        window.setTimeout(function () { self.next(); }, 220);
      }
    }

    pickMulti(chip) {
      var screen = chip.closest('[data-cq1-screen]');
      var wrap = chip.parentElement;
      var limit = parseInt(screen.dataset.cq1Multi, 10) || 3;
      var chosen = wrap.querySelectorAll('[aria-pressed="true"]');
      var isOn = chip.getAttribute('aria-pressed') === 'true';

      if (!isOn && chosen.length >= limit) return;   // hard stop, never silently swap
      chip.setAttribute('aria-pressed', isOn ? 'false' : 'true');

      var count = wrap.querySelectorAll('[aria-pressed="true"]').length;
      wrap.classList.toggle('cq1-is-full', count >= limit);
      this.paintMultiCounter(count, limit);
    }

    /* The counter shows "0 of 3 selected" from the moment the screen appears.
       It explains why Continue is disabled, so it cannot start blank. */
    paintMultiCounter(count, limit) {
      var screen = this.screenAt(4);
      if (!limit) limit = screen ? (parseInt(screen.dataset.cq1Multi, 10) || 3) : 3;

      var counter = this.one('[data-cq1-counter]');
      if (counter) {
        var fmt = new Intl.NumberFormat(document.documentElement.lang || undefined);
        counter.textContent = (this.dataset.counterTpl || '').replace('{n}', fmt.format(count));
      }
      var btn = this.one('[data-cq1-continue]');
      if (btn) btn.setAttribute('aria-disabled', count === limit ? 'false' : 'true');
    }

    recordAndAdvance(btn) {
      var screen = btn.closest('[data-cq1-screen]');
      var q = screen.dataset.cq1Question;

      if (screen.dataset.cq1Multi) {
        var picked = [];
        screen.querySelectorAll('[aria-pressed="true"]').forEach(function (c) {
          picked.push(c.dataset.cq1Answer);
        });
        this.answers[q] = { answer: picked, collection: null };
      }

      var range = screen.querySelector('[data-cq1-range]');
      if (range) this.answers[q] = { answer: parseInt(range.value, 10), collection: null };

      this.track('quiz_question_answered', { question: q });
      this.save();
      this.next();
    }

    /* ---------- matching ----------
       Rule 1: if the first two collection answers agree, that is the collection.
               If they disagree, the moment question breaks the tie. If all three
               differ, the first answer wins.
       Rule 2: the slider value is the bracelet level; if that exact level is
               unavailable, the nearest available one in the same collection wins,
               ties going to the quieter piece. */
    resolveCollection() {
      var c1 = this.answers.q1 && this.answers.q1.collection;
      var c3 = this.answers.q3 && this.answers.q3.collection;
      var c5 = this.answers.q5 && this.answers.q5.collection;
      if (c1 === c3) return c1;
      if (c5 === c1 || c5 === c3) return c5;
      return c1;
    }

    resolveResult() {
      var collection = this.resolveCollection();
      var level = (this.answers.q6 && this.answers.q6.answer) || 3;

      var all = this.all('.cq1-result');
      var live = all.filter(function (r) { return r.dataset.cq1Active !== 'false'; });

      function nearest(pool) {
        if (!pool.length) return null;
        return pool.slice().sort(function (a, b) {
          var la = parseInt(a.dataset.cq1Level, 10);
          var lb = parseInt(b.dataset.cq1Level, 10);
          return Math.abs(la - level) - Math.abs(lb - level) || la - lb;
        })[0];
      }

      var inCollection = live.filter(function (r) { return r.dataset.cq1Collection === collection; });
      return nearest(inCollection) || nearest(live) || all[0];
    }

    currentResultId() {
      var active = this.one('.cq1-result.cq1-is-active');
      return active ? active.dataset.cq1Result : null;
    }

    runResult() {
      this.show(7);

      var panel = this.resolveResult();
      var img = panel && panel.querySelector('img[data-src]');
      if (img && !img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));

      this.track('quiz_complete', { result: panel ? panel.dataset.cq1Result : null });

      var self = this;
      this.loadTimer = window.setTimeout(function () {
        self.all('.cq1-result').forEach(function (r) {
          r.classList.remove('cq1-is-active');
          r.setAttribute('hidden', '');
        });
        if (panel) {
          panel.classList.add('cq1-is-active');
          panel.removeAttribute('hidden');
        }
        self.show(8);
        self.track('result_view', { result: panel ? panel.dataset.cq1Result : null });
      }, this.loadingMs);
    }

    /* ---------- back ---------- */
    bindBack() {
      var self = this;
      if (this.backBtn) {
        this.backBtn.addEventListener('click', function () {
          if (self.current > 1) self.show(self.current - 1);
        });
      }
      this.onPop = function () {
        var m = /#step(\d+)/.exec(window.location.hash);
        if (m) {
          var step = parseInt(m[1], 10);
          if (step !== self.current) self.show(step);
        }
      };
      window.addEventListener('popstate', this.onPop);
    }

    /* ---------- slider ----------
       Semantic, not spatial: 1 always means quiet and 5 always means bold,
       whichever side of the screen they land on. A native range reverses itself
       under dir="rtl" and the end labels follow, so never compensate here. */
    bindSlider() {
      var range = this.one('[data-cq1-range]');
      if (!range) return;
      var announce = function () {
        range.setAttribute('aria-valuetext', range.getAttribute('data-text-' + range.value) || range.value);
      };
      range.addEventListener('input', announce);
      announce();
    }

    boot() {
      var saved = this.restore();
      if (saved && saved.a && saved.s && saved.s < 7) {
        this.answers = saved.a;
        this.show(saved.s);
        return;
      }
      var m = /#step(\d+)/.exec(window.location.hash);
      var step = m ? parseInt(m[1], 10) : 0;
      this.show(step > 0 && step < 7 ? step : 0);
    }

    disconnectedCallback() {
      clearTimeout(this.loadTimer);
      if (this.onPop) window.removeEventListener('popstate', this.onPop);
    }
  }

  if (!customElements.get('charms-quiz-one')) {
    customElements.define('charms-quiz-one', CharmsQuizOne);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charms-quiz-two"] && !Shopify.designMode) return;
  try {
    
  /* Port of the prelander script. Same flow, same timings, same result rule:
     question two alone decides the type. Everything else builds the bracelet.
     Scoped to the element rather than the document, so two of these on one page
     would not fight, and so it survives a section re-render in the theme editor. */
  class CharmsQuizTwo extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      this.quickMs = parseInt(this.dataset.quickMs, 10) || 7000;
      this.threadMs = parseInt(this.dataset.threadMs, 10) || 2400;
      this.startMetal = this.dataset.metal || 'gold';

      this.state = {
        type: null, charms: [], metal: this.startMetal,
        meaning: 3, filled: 0, last: null, q1done: false, q5done: false
      };

      this.copy = this.readCopy();
      this.screens = {};
      this.all('[data-cq2-screen]').forEach((s) => {
        this.screens[s.dataset.cq2Screen] = s;
      });
      if (!this.screens.intro) return;

      this.rail = this.one('[data-cq2-rail]');
      this.countEl = this.one('[data-cq2-count]');
      this.slots = this.all('[data-cq2-slots] .cq2-slot');

      this.bindGo();
      this.bindQ1();
      this.bindQ2();
      this.bindQ3();
      this.bindQ5();
      this.bindRestart();
      this.countLine();
    }

    disconnectedCallback() {
      clearTimeout(this.rapidTimer);
      clearTimeout(this.threadTimer);
      clearTimeout(this.nameTimer);
    }

    one(sel) { return this.querySelector(sel); }
    all(sel) { return Array.prototype.slice.call(this.querySelectorAll(sel)); }

    /* ---------- copy, read once from the hidden block ---------- */
    readCopy() {
      const box = this.one('[data-cq2-copy]');
      if (!box) return { slider: [], charms: {}, rapid: [], types: {} };
      const text = (el) => (el ? el.textContent.trim() : '');
      return {
        countOne: text(box.querySelector('[data-cq2-count-one]')),
        countMany: text(box.querySelector('[data-cq2-count-many]')),
        slider: Array.prototype.slice
          .call(box.querySelectorAll('[data-cq2-slider-steps] li'))
          .map(text),
        charms: Object.fromEntries(
          Array.prototype.slice
            .call(box.querySelectorAll('[data-cq2-charm-names] [data-charm]'))
            .map((e) => [e.dataset.charm, text(e)])
        ),
        rapid: Array.prototype.slice
          .call(box.querySelectorAll('[data-cq2-rapid] [data-key]'))
          .map((r) => ({
            metal: r.dataset.metal === 'true',
            charms: [r.dataset.charmA || '', r.dataset.charmB || ''],
            q: text(r.querySelector('[data-q]')),
            a: Array.prototype.slice.call(r.querySelectorAll('[data-a]')).map(text)
          })),
        types: Object.fromEntries(
          Array.prototype.slice
            .call(box.querySelectorAll('[data-cq2-types] [data-type]'))
            .map((d) => [
              d.dataset.type,
              {
                t: text(d.querySelector('[data-name]')),
                p: text(d.querySelector('[data-punch]')),
                b: text(d.querySelector('[data-body]'))
              }
            ])
        )
      };
    }

    /* ---------- screens ---------- */
    show(name) {
      if (!this.screens[name]) return;
      Object.keys(this.screens).forEach((key) => {
        this.screens[key].classList.toggle('on', key === name);
      });
      if (this.rail) this.rail.hidden = name === 'intro';
      window.scrollTo({ top: 0, behavior: this.reduced ? 'auto' : 'smooth' });
    }

    /* ---------- the rail ---------- */
    collect(charm) {
      if (!charm) return;
      const slot = this.slots[this.state.filled];
      if (!slot) return;
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('class', 'cq2-charm cq2-charm--sm');
      const use = document.createElementNS(ns, 'use');
      use.setAttribute('href', '#c-' + charm);
      svg.appendChild(use);
      slot.appendChild(svg);
      slot.classList.add('cq2-filled');
      this.state.filled++;
      this.state.charms.push(charm);
      this.countLine();
      this.flashName(this.copy.charms[charm]);
    }

    countLine() {
      if (!this.countEl) return;
      const n = this.state.filled;
      const tpl = n === 1 ? this.copy.countOne : this.copy.countMany;
      this.countEl.textContent = (tpl || '').replace('{n}', n);
    }

    /* the counter doubles as the charm's name for a beat, so she learns what each
       charm is called before she ever reaches the collection page */
    flashName(name) {
      if (!name || !this.countEl) return;
      const el = this.countEl;
      clearTimeout(this.nameTimer);
      el.classList.remove('is-name');
      void el.offsetWidth;
      el.classList.add('is-name');
      el.textContent = name;
      this.nameTimer = setTimeout(() => {
        el.classList.remove('is-name');
        this.countLine();
      }, 1800);
    }

    bindGo() {
      const start = this.one('[data-cq2-go="q1"]');
      if (start) start.addEventListener('click', () => this.show('q1'));
    }

    /* ---------- Q1 tap + drag ---------- */
    bindQ1() {
      this.all('[data-cq2-scene]').forEach((card) => {
        let sx = 0;
        let sy = 0;
        let drag = false;

        const pick = () => {
          if (this.state.q1done) return;
          this.state.q1done = true;
          this.collect(card.dataset.cq2Charm);
          Array.prototype.slice.call(card.parentElement.children).forEach((c) => {
            if (c !== card) c.classList.add('cq2-gone');
          });
          card.style.transform = 'scale(1.03)';
          setTimeout(() => this.show('q2'), this.reduced ? 0 : 420);
        };

        card.addEventListener('click', () => { if (!drag) pick(); });
        card.addEventListener('pointerdown', (e) => {
          sx = e.clientX; sy = e.clientY; drag = false;
          card.setPointerCapture(e.pointerId);
          card.style.transition = 'none';
        });
        card.addEventListener('pointermove', (e) => {
          if (!e.buttons && e.pointerType === 'mouse') return;
          const dx = e.clientX - sx;
          const dy = e.clientY - sy;
          if (Math.abs(dx) + Math.abs(dy) > 8) {
            drag = true;
            card.style.transform = 'translate(' + dx + 'px,' + dy * 0.4 + 'px) rotate(' + dx * 0.05 + 'deg)';
          }
        });
        card.addEventListener('pointerup', (e) => {
          card.style.transition = '';
          const dx = e.clientX - sx;
          const dy = e.clientY - sy;
          if (Math.abs(dx) > 46 || Math.abs(dy) > 60) pick();
          else card.style.transform = '';
          setTimeout(() => { drag = false; }, 60);
        });
        card.addEventListener('pointercancel', () => {
          card.style.transition = '';
          card.style.transform = '';
          drag = false;
        });
      });
    }

    /* ---------- Q2 — the only answer that decides the result ---------- */
    bindQ2() {
      this.all('[data-cq2-tile]').forEach((tile) => {
        tile.addEventListener('click', () => {
          this.state.type = tile.dataset.cq2Result || null;
          this.collect(tile.dataset.cq2Charm);
          setTimeout(() => {
            this.show('q3');
            this.drawPreview();
          }, this.reduced ? 0 : 260);
        });
      });
    }

    /* ---------- Q3 slider ---------- */
    bindQ3() {
      this.slider = this.one('[data-cq2-slider]');
      this.preview = this.one('[data-cq2-preview]');
      this.readout = this.one('[data-cq2-readout]');
      if (this.slider) this.slider.addEventListener('input', () => this.drawPreview());

      const go = this.one('[data-cq2-go="q4"]');
      if (go) {
        go.addEventListener('click', () => {
          const n = this.state.meaning;
          this.collect(go.dataset.cq2Charm || 'bead');
          const bead = this.slots[2] ? this.slots[2].querySelector('.cq2-charm') : null;
          if (bead) bead.style.width = 24 + n * 3 + 'px';
          this.show('q4');
          this.runRapid(0);
        });
      }
    }

    drawPreview() {
      if (!this.slider) return;
      const n = parseInt(this.slider.value, 10) || 1;
      this.state.meaning = n;
      if (this.preview) {
        this.preview.innerHTML = '';
        const seq = ['heart', 'bead', 'star', 'bead', 'flower'];
        const ns = 'http://www.w3.org/2000/svg';
        for (let i = 0; i < n; i++) {
          const svg = document.createElementNS(ns, 'svg');
          svg.setAttribute('class', 'cq2-charm cq2-charm--sm');
          svg.style.position = 'relative';
          svg.style.zIndex = '1';
          const use = document.createElementNS(ns, 'use');
          use.setAttribute('href', '#c-' + seq[i]);
          svg.appendChild(use);
          this.preview.appendChild(svg);
          const delay = this.reduced ? 0 : i * 70;
          setTimeout(() => svg.classList.add('show'), delay);
        }
      }
      if (this.readout) this.readout.textContent = this.copy.slider[n - 1] || '';
    }

    /* ---------- Q4 rapid fire ---------- */
    setMetal(metal) {
      if (!metal) return;
      this.state.metal = metal;
      this.dataset.metal = metal;
    }

    runRapid(index) {
      clearTimeout(this.rapidTimer);
      const list = this.copy.rapid;
      if (!list.length || index >= list.length) {
        this.collect(this.state.last || 'key');
        this.show('q5');
        return;
      }

      const r = list[index];
      const qEl = this.one('[data-cq2-rapidq]');
      if (qEl) qEl.textContent = r.q;
      this.all('[data-cq2-dots] i').forEach((d, k) => d.classList.toggle('on', k <= index));

      const bin = this.one('[data-cq2-binary]');
      if (bin) {
        bin.innerHTML = '';
        r.a.forEach((label, k) => {
          const b = document.createElement('button');
          b.className = 'cq2-bbtn';
          b.type = 'button';
          b.textContent = label;
          b.addEventListener('click', () => {
            clearTimeout(this.rapidTimer);
            b.classList.add('cq2-flash');
            this.applyRapid(r, k);
            setTimeout(() => this.runRapid(index + 1), this.reduced ? 0 : 240);
          }, { once: true });
          bin.appendChild(b);
        });
      }

      const bar = this.one('[data-cq2-timerbar]');
      if (bar && !this.reduced) {
        bar.style.transition = 'none';
        bar.style.transform = 'scaleX(1)';
        void bar.offsetWidth;
        bar.style.transition = 'transform ' + this.quickMs + 'ms linear';
        bar.style.transform = 'scaleX(0)';
      }

      this.rapidTimer = setTimeout(() => {
        this.applyRapid(r, 0);
        this.runRapid(index + 1);
      }, this.quickMs + 200);
    }

    applyRapid(r, k) {
      if (r.metal) this.setMetal(k === 0 ? 'gold' : 'silver');
      const charm = r.charms[k];
      if (charm) this.state.last = charm;
    }

    /* ---------- Q5 ---------- */
    bindQ5() {
      const rows = this.all('[data-cq2-row]');
      rows.forEach((row) => {
        row.addEventListener('click', () => {
          if (this.state.q5done) return;
          this.state.q5done = true;
          this.collect(row.dataset.cq2Charm);
          const blank = this.one('[data-cq2-blank]');
          if (blank) {
            blank.textContent = row.dataset.cq2Fill || '';
            blank.classList.add('cq2-done');
          }
          const wrap = this.one('[data-cq2-q5rows]');
          if (wrap) wrap.classList.add('cq2-away');
          setTimeout(() => {
            this.show('thread');
            this.threadTimer = setTimeout(() => this.reveal(), this.reduced ? 200 : this.threadMs);
          }, this.reduced ? 0 : 1500);
        });
      });
    }

    /* ---------- result ---------- */
    reveal() {
      const t = this.copy.types[this.state.type] || this.copy.types[Object.keys(this.copy.types)[0]];
      if (t) {
        const title = this.one('[data-cq2-title]');
        const punch = this.one('[data-cq2-punch]');
        const body = this.one('[data-cq2-body]');
        if (title) title.textContent = t.t;
        if (punch) punch.textContent = t.p;
        if (body) body.textContent = t.b;
      }
      this.show('result');
    }

    bindRestart() {
      const btn = this.one('[data-cq2-restart]');
      if (btn) btn.addEventListener('click', () => window.location.reload());
    }
  }

  if (!customElements.get('charms-quiz-two')) {
    customElements.define('charms-quiz-two', CharmsQuizTwo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charms_announcement_bar_off"] && !Shopify.designMode) return;
  try {
    
  class CharmsAnnouncement extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-charms-track]');
      this.slides = Array.from(this.querySelectorAll('[data-charms-slide]'));
      if (!this.track || this.slides.length === 0) return;

      this.index = 0;
      this.timer = null;

      const prev = this.querySelector('[data-charms-prev]');
      const next = this.querySelector('[data-charms-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.go(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    step(direction) {
      const total = this.slides.length;
      this.go((this.index + direction + total) % total);
    }

    go(index) {
      this.index = index;
      this.track.style.transform = 'translateX(' + index * -100 + '%)';
      this.slides.forEach((slide, i) => {
        if (i === index) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }

    start() {
      this.stop();
      if (this.slides.length < 2) return;
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const speed = parseInt(this.dataset.speed, 10) || 5;
      this.timer = setInterval(() => this.step(1), speed * 1000);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('charms-announcement')) {
    customElements.define('charms-announcement', CharmsAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charms_product_layout_offer"] && !Shopify.designMode) return;
  try {
    
  class CharmsGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-charms-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-charms-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-charms-thumb]'));
      if (!this.viewport || this.slides.length === 0) return;

      this.index = 0;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.goTo(parseInt(thumb.dataset.index, 10) || 0);
        });
      });

      const prev = this.querySelector('[data-charms-prev]');
      const next = this.querySelector('[data-charms-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(-1);
        }
      });

      this.onScroll = this.onScroll.bind(this);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
    }

    onScroll() {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const width = this.viewport.clientWidth;
        if (width === 0) return;
        this.setActive(Math.round(this.viewport.scrollLeft / width));
      }, 80);
    }

    step(direction) {
      const total = this.slides.length;
      let target = this.index + direction;
      if (this.dataset.loop === 'true') {
        target = (target + total) % total;
      } else {
        target = Math.max(0, Math.min(total - 1, target));
      }
      this.goTo(target);
    }

    goTo(index) {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.viewport.scrollTo({ left: this.viewport.clientWidth * index, behavior: behavior });
      this.setActive(index);
    }

    setActive(index) {
      if (index === this.index) return;
      this.index = index;
      this.thumbs.forEach((thumb, i) => {
        if (i === index) {
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.classList.remove('is-active');
          thumb.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('charms-gallery')) {
    customElements.define('charms-gallery', CharmsGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
